import { default as energy_45green_45practices0de8MAgY4BMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue?macro=true";
import { default as fun_45part_45journeyMuhSnV1T4gMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue?macro=true";
import { default as homesafe_45colorado_45master_45builderAxsFvarOjdMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue?macro=true";
import { default as indexUkWhaQkYZAMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/index.vue?macro=true";
import { default as our_45team5xVgsDj4ZjMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue?macro=true";
import { default as preferred_45lendere2zlfM1QQMMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue?macro=true";
import { default as realtor_45resourcesbKzEeiiuNtMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue?macro=true";
import { default as _91post_93KORm9fNcMFMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/blog/[post].vue?macro=true";
import { default as indexRJHnwMEQwcMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue?macro=true";
import { default as indexYEbOt6IJkyMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46slug_93MYp4AmwZQrMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue?macro=true";
import { default as indexyUOUSYB9n4Meta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue?macro=true";
import { default as central_45park_45special_45offerH07nTc6wQRMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue?macro=true";
import { default as ask_45a_45questionuzVDQshkhbMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue?macro=true";
import { default as career_45opportunitiesU3uhIWCUUNMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue?macro=true";
import { default as faqnLaYHxIVMBMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue?macro=true";
import { default as homeowner_45resources9Z1PQHtGGNMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue?macro=true";
import { default as indexZASqonLn8xMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue?macro=true";
import { default as our_45locationsEOo1KtdCjvMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue?macro=true";
import { default as current_45offerslwnaHG0MTVMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/current-offers.vue?macro=true";
import { default as indexCFddkTCeRJMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue?macro=true";
import { default as indexe8nQWhpmOpMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/events/index.vue?macro=true";
import { default as index4Cb07kmk7tMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue?macro=true";
import { default as indexjPblkprG8pMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue?macro=true";
import { default as index3aNaOTlSHAMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue?macro=true";
import { default as index10IKN9T6NEMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue?macro=true";
import { default as indexySc6tRFH6sMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/index.vue?macro=true";
import { default as knolls_45hoa_45informationZDVQnWjnuYMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue?macro=true";
import { default as land_45acquisition9T0C6HEYJxMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue?macro=true";
import { default as brents_45place0CNy016Q3KMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue?macro=true";
import { default as experience_45lower_45maintenanceJ2eThnNliVMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue?macro=true";
import { default as _91testimonial_93R87joEoPTTMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue?macro=true";
import { default as indexFfHfyZ1niQMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue?macro=true";
import { default as indexWZWUgJgfieMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue?macro=true";
import { default as whats_45lifefullness1KMYMjENfVMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue?macro=true";
import { default as _91_46_46_46slug_93q84ophYoI2Meta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue?macro=true";
import { default as my_45favorites47rqCRZYO4Meta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/my-favorites.vue?macro=true";
import { default as new_45home_45search9o2Uf96QDvMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/new-home-search.vue?macro=true";
import { default as easyhouseL0DEifuAj2Meta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue?macro=true";
import { default as limitededitionxtULVOTHybMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue?macro=true";
import { default as wee_45cottagepD4K2dk9z3Meta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue?macro=true";
import { default as indexJUyLThjukxMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue?macro=true";
import { default as our_45neighborhoodsMWelmsyOlJMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue?macro=true";
import { default as partner_45with_45us1CagWEcvsnMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue?macro=true";
import { default as peacockd9ySbgvt7gMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/peacock.vue?macro=true";
import { default as privacytermsmC2DDu25oIMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/privacyterms.vue?macro=true";
import { default as sandboxCEG5UviQVWMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/sandbox.vue?macro=true";
import { default as _91_46_46_46slug_93VgXoNwIMBgMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue?macro=true";
import { default as component_45stub2sI0tKXwdQMeta } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stub2sI0tKXwdQ } from "/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: energy_45green_45practices0de8MAgY4BMeta?.name ?? "about-us-energy-green-practices",
    path: energy_45green_45practices0de8MAgY4BMeta?.path ?? "/about-us/energy-green-practices",
    meta: energy_45green_45practices0de8MAgY4BMeta || {},
    alias: energy_45green_45practices0de8MAgY4BMeta?.alias || [],
    redirect: energy_45green_45practices0de8MAgY4BMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue").then(m => m.default || m)
  },
  {
    name: fun_45part_45journeyMuhSnV1T4gMeta?.name ?? "about-us-fun-part-journey",
    path: fun_45part_45journeyMuhSnV1T4gMeta?.path ?? "/about-us/fun-part-journey",
    meta: fun_45part_45journeyMuhSnV1T4gMeta || {},
    alias: fun_45part_45journeyMuhSnV1T4gMeta?.alias || [],
    redirect: fun_45part_45journeyMuhSnV1T4gMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue").then(m => m.default || m)
  },
  {
    name: homesafe_45colorado_45master_45builderAxsFvarOjdMeta?.name ?? "about-us-homesafe-colorado-master-builder",
    path: homesafe_45colorado_45master_45builderAxsFvarOjdMeta?.path ?? "/about-us/homesafe-colorado-master-builder",
    meta: homesafe_45colorado_45master_45builderAxsFvarOjdMeta || {},
    alias: homesafe_45colorado_45master_45builderAxsFvarOjdMeta?.alias || [],
    redirect: homesafe_45colorado_45master_45builderAxsFvarOjdMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue").then(m => m.default || m)
  },
  {
    name: indexUkWhaQkYZAMeta?.name ?? "about-us",
    path: indexUkWhaQkYZAMeta?.path ?? "/about-us",
    meta: indexUkWhaQkYZAMeta || {},
    alias: indexUkWhaQkYZAMeta?.alias || [],
    redirect: indexUkWhaQkYZAMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45team5xVgsDj4ZjMeta?.name ?? "about-us-our-team",
    path: our_45team5xVgsDj4ZjMeta?.path ?? "/about-us/our-team",
    meta: our_45team5xVgsDj4ZjMeta || {},
    alias: our_45team5xVgsDj4ZjMeta?.alias || [],
    redirect: our_45team5xVgsDj4ZjMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue").then(m => m.default || m)
  },
  {
    name: preferred_45lendere2zlfM1QQMMeta?.name ?? "about-us-preferred-lender",
    path: preferred_45lendere2zlfM1QQMMeta?.path ?? "/about-us/preferred-lender",
    meta: preferred_45lendere2zlfM1QQMMeta || {},
    alias: preferred_45lendere2zlfM1QQMMeta?.alias || [],
    redirect: preferred_45lendere2zlfM1QQMMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue").then(m => m.default || m)
  },
  {
    name: realtor_45resourcesbKzEeiiuNtMeta?.name ?? "about-us-realtor-resources",
    path: realtor_45resourcesbKzEeiiuNtMeta?.path ?? "/about-us/realtor-resources",
    meta: realtor_45resourcesbKzEeiiuNtMeta || {},
    alias: realtor_45resourcesbKzEeiiuNtMeta?.alias || [],
    redirect: realtor_45resourcesbKzEeiiuNtMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue").then(m => m.default || m)
  },
  {
    name: _91post_93KORm9fNcMFMeta?.name ?? "blog-post",
    path: _91post_93KORm9fNcMFMeta?.path ?? "/blog/:post()",
    meta: _91post_93KORm9fNcMFMeta || {},
    alias: _91post_93KORm9fNcMFMeta?.alias || [],
    redirect: _91post_93KORm9fNcMFMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/blog/[post].vue").then(m => m.default || m)
  },
  {
    name: indexRJHnwMEQwcMeta?.name ?? "blog-category-category",
    path: indexRJHnwMEQwcMeta?.path ?? "/blog/category/:category()",
    meta: indexRJHnwMEQwcMeta || {},
    alias: indexRJHnwMEQwcMeta?.alias || [],
    redirect: indexRJHnwMEQwcMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexYEbOt6IJkyMeta?.name ?? "blog",
    path: indexYEbOt6IJkyMeta?.path ?? "/blog",
    meta: indexYEbOt6IJkyMeta || {},
    alias: indexYEbOt6IJkyMeta?.alias || [],
    redirect: indexYEbOt6IJkyMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93MYp4AmwZQrMeta?.name ?? "campaigns-slug",
    path: _91_46_46_46slug_93MYp4AmwZQrMeta?.path ?? "/campaigns/:slug(.*)*",
    meta: _91_46_46_46slug_93MYp4AmwZQrMeta || {},
    alias: _91_46_46_46slug_93MYp4AmwZQrMeta?.alias || [],
    redirect: _91_46_46_46slug_93MYp4AmwZQrMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexyUOUSYB9n4Meta?.name ?? "campaigns",
    path: indexyUOUSYB9n4Meta?.path ?? "/campaigns",
    meta: indexyUOUSYB9n4Meta || {},
    alias: indexyUOUSYB9n4Meta?.alias || [],
    redirect: indexyUOUSYB9n4Meta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: central_45park_45special_45offerH07nTc6wQRMeta?.name ?? "central-park-special-offer",
    path: central_45park_45special_45offerH07nTc6wQRMeta?.path ?? "/central-park-special-offer",
    meta: central_45park_45special_45offerH07nTc6wQRMeta || {},
    alias: central_45park_45special_45offerH07nTc6wQRMeta?.alias || [],
    redirect: central_45park_45special_45offerH07nTc6wQRMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue").then(m => m.default || m)
  },
  {
    name: ask_45a_45questionuzVDQshkhbMeta?.name ?? "contact-us-ask-a-question",
    path: ask_45a_45questionuzVDQshkhbMeta?.path ?? "/contact-us/ask-a-question",
    meta: ask_45a_45questionuzVDQshkhbMeta || {},
    alias: ask_45a_45questionuzVDQshkhbMeta?.alias || [],
    redirect: ask_45a_45questionuzVDQshkhbMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue").then(m => m.default || m)
  },
  {
    name: career_45opportunitiesU3uhIWCUUNMeta?.name ?? "contact-us-career-opportunities",
    path: career_45opportunitiesU3uhIWCUUNMeta?.path ?? "/contact-us/career-opportunities",
    meta: career_45opportunitiesU3uhIWCUUNMeta || {},
    alias: career_45opportunitiesU3uhIWCUUNMeta?.alias || [],
    redirect: career_45opportunitiesU3uhIWCUUNMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue").then(m => m.default || m)
  },
  {
    name: faqnLaYHxIVMBMeta?.name ?? "contact-us-faq",
    path: faqnLaYHxIVMBMeta?.path ?? "/contact-us/faq",
    meta: faqnLaYHxIVMBMeta || {},
    alias: faqnLaYHxIVMBMeta?.alias || [],
    redirect: faqnLaYHxIVMBMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue").then(m => m.default || m)
  },
  {
    name: homeowner_45resources9Z1PQHtGGNMeta?.name ?? "contact-us-homeowner-resources",
    path: homeowner_45resources9Z1PQHtGGNMeta?.path ?? "/contact-us/homeowner-resources",
    meta: homeowner_45resources9Z1PQHtGGNMeta || {},
    alias: homeowner_45resources9Z1PQHtGGNMeta?.alias || [],
    redirect: homeowner_45resources9Z1PQHtGGNMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue").then(m => m.default || m)
  },
  {
    name: indexZASqonLn8xMeta?.name ?? "contact-us",
    path: indexZASqonLn8xMeta?.path ?? "/contact-us",
    meta: indexZASqonLn8xMeta || {},
    alias: indexZASqonLn8xMeta?.alias || [],
    redirect: indexZASqonLn8xMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45locationsEOo1KtdCjvMeta?.name ?? "contact-us-our-locations",
    path: our_45locationsEOo1KtdCjvMeta?.path ?? "/contact-us/our-locations",
    meta: our_45locationsEOo1KtdCjvMeta || {},
    alias: our_45locationsEOo1KtdCjvMeta?.alias || [],
    redirect: our_45locationsEOo1KtdCjvMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue").then(m => m.default || m)
  },
  {
    name: current_45offerslwnaHG0MTVMeta?.name ?? "current-offers",
    path: current_45offerslwnaHG0MTVMeta?.path ?? "/current-offers",
    meta: current_45offerslwnaHG0MTVMeta || {},
    alias: current_45offerslwnaHG0MTVMeta?.alias || [],
    redirect: current_45offerslwnaHG0MTVMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/current-offers.vue").then(m => m.default || m)
  },
  {
    name: indexCFddkTCeRJMeta?.name ?? "events-event",
    path: indexCFddkTCeRJMeta?.path ?? "/events/:event()",
    meta: indexCFddkTCeRJMeta || {},
    alias: indexCFddkTCeRJMeta?.alias || [],
    redirect: indexCFddkTCeRJMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue").then(m => m.default || m)
  },
  {
    name: indexe8nQWhpmOpMeta?.name ?? "events",
    path: indexe8nQWhpmOpMeta?.path ?? "/events",
    meta: indexe8nQWhpmOpMeta || {},
    alias: indexe8nQWhpmOpMeta?.alias || [],
    redirect: indexe8nQWhpmOpMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: index4Cb07kmk7tMeta?.name ?? "homes-location-community",
    path: index4Cb07kmk7tMeta?.path ?? "/homes/:location()/:community()",
    meta: index4Cb07kmk7tMeta || {},
    alias: index4Cb07kmk7tMeta?.alias || [],
    redirect: index4Cb07kmk7tMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjPblkprG8pMeta?.name ?? "homes-location-community-models-model",
    path: indexjPblkprG8pMeta?.path ?? "/homes/:location()/:community()/models/:model()",
    meta: indexjPblkprG8pMeta || {},
    alias: indexjPblkprG8pMeta?.alias || [],
    redirect: indexjPblkprG8pMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue").then(m => m.default || m)
  },
  {
    name: index3aNaOTlSHAMeta?.name ?? "homes-location-community-plans-plan",
    path: index3aNaOTlSHAMeta?.path ?? "/homes/:location()/:community()/plans/:plan()",
    meta: index3aNaOTlSHAMeta || {},
    alias: index3aNaOTlSHAMeta?.alias || [],
    redirect: index3aNaOTlSHAMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue").then(m => m.default || m)
  },
  {
    name: index10IKN9T6NEMeta?.name ?? "homes-location-community-qmi-home",
    path: index10IKN9T6NEMeta?.path ?? "/homes/:location()/:community()/qmi/:home()",
    meta: index10IKN9T6NEMeta || {},
    alias: index10IKN9T6NEMeta?.alias || [],
    redirect: index10IKN9T6NEMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue").then(m => m.default || m)
  },
  {
    name: indexySc6tRFH6sMeta?.name ?? "index",
    path: indexySc6tRFH6sMeta?.path ?? "/",
    meta: indexySc6tRFH6sMeta || {},
    alias: indexySc6tRFH6sMeta?.alias || [],
    redirect: indexySc6tRFH6sMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: knolls_45hoa_45informationZDVQnWjnuYMeta?.name ?? "knolls-hoa-information",
    path: knolls_45hoa_45informationZDVQnWjnuYMeta?.path ?? "/knolls-hoa-information",
    meta: knolls_45hoa_45informationZDVQnWjnuYMeta || {},
    alias: knolls_45hoa_45informationZDVQnWjnuYMeta?.alias || [],
    redirect: knolls_45hoa_45informationZDVQnWjnuYMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue").then(m => m.default || m)
  },
  {
    name: land_45acquisition9T0C6HEYJxMeta?.name ?? "land-acquisition",
    path: land_45acquisition9T0C6HEYJxMeta?.path ?? "/land-acquisition",
    meta: land_45acquisition9T0C6HEYJxMeta || {},
    alias: land_45acquisition9T0C6HEYJxMeta?.alias || [],
    redirect: land_45acquisition9T0C6HEYJxMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue").then(m => m.default || m)
  },
  {
    name: brents_45place0CNy016Q3KMeta?.name ?? "lifestyle-brents-place",
    path: brents_45place0CNy016Q3KMeta?.path ?? "/lifestyle/brents-place",
    meta: brents_45place0CNy016Q3KMeta || {},
    alias: brents_45place0CNy016Q3KMeta?.alias || [],
    redirect: brents_45place0CNy016Q3KMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue").then(m => m.default || m)
  },
  {
    name: experience_45lower_45maintenanceJ2eThnNliVMeta?.name ?? "lifestyle-experience-lower-maintenance",
    path: experience_45lower_45maintenanceJ2eThnNliVMeta?.path ?? "/lifestyle/experience-lower-maintenance",
    meta: experience_45lower_45maintenanceJ2eThnNliVMeta || {},
    alias: experience_45lower_45maintenanceJ2eThnNliVMeta?.alias || [],
    redirect: experience_45lower_45maintenanceJ2eThnNliVMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue").then(m => m.default || m)
  },
  {
    name: _91testimonial_93R87joEoPTTMeta?.name ?? "lifestyle-reviews-testimonial",
    path: _91testimonial_93R87joEoPTTMeta?.path ?? "/lifestyle/reviews/:testimonial()",
    meta: _91testimonial_93R87joEoPTTMeta || {},
    alias: _91testimonial_93R87joEoPTTMeta?.alias || [],
    redirect: _91testimonial_93R87joEoPTTMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue").then(m => m.default || m)
  },
  {
    name: indexFfHfyZ1niQMeta?.name ?? "lifestyle-reviews-category-category",
    path: indexFfHfyZ1niQMeta?.path ?? "/lifestyle/reviews/category/:category()",
    meta: indexFfHfyZ1niQMeta || {},
    alias: indexFfHfyZ1niQMeta?.alias || [],
    redirect: indexFfHfyZ1niQMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexWZWUgJgfieMeta?.name ?? "lifestyle-reviews",
    path: indexWZWUgJgfieMeta?.path ?? "/lifestyle/reviews",
    meta: indexWZWUgJgfieMeta || {},
    alias: indexWZWUgJgfieMeta?.alias || [],
    redirect: indexWZWUgJgfieMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: whats_45lifefullness1KMYMjENfVMeta?.name ?? "lifestyle-whats-lifefullness",
    path: whats_45lifefullness1KMYMjENfVMeta?.path ?? "/lifestyle/whats-lifefullness",
    meta: whats_45lifefullness1KMYMjENfVMeta || {},
    alias: whats_45lifefullness1KMYMjENfVMeta?.alias || [],
    redirect: whats_45lifefullness1KMYMjENfVMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93q84ophYoI2Meta?.name ?? "marshallfire-slug",
    path: _91_46_46_46slug_93q84ophYoI2Meta?.path ?? "/marshallfire/:slug(.*)*",
    meta: _91_46_46_46slug_93q84ophYoI2Meta || {},
    alias: _91_46_46_46slug_93q84ophYoI2Meta?.alias || [],
    redirect: _91_46_46_46slug_93q84ophYoI2Meta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue").then(m => m.default || m)
  },
  {
    name: my_45favorites47rqCRZYO4Meta?.name ?? "my-favorites",
    path: my_45favorites47rqCRZYO4Meta?.path ?? "/my-favorites",
    meta: my_45favorites47rqCRZYO4Meta || {},
    alias: my_45favorites47rqCRZYO4Meta?.alias || [],
    redirect: my_45favorites47rqCRZYO4Meta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: new_45home_45search9o2Uf96QDvMeta?.name ?? "new-home-search",
    path: new_45home_45search9o2Uf96QDvMeta?.path ?? "/new-home-search",
    meta: new_45home_45search9o2Uf96QDvMeta || {},
    alias: new_45home_45search9o2Uf96QDvMeta?.alias || [],
    redirect: new_45home_45search9o2Uf96QDvMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/new-home-search.vue").then(m => m.default || m)
  },
  {
    name: easyhouseL0DEifuAj2Meta?.name ?? "our-homes-home-collections-easyhouse",
    path: easyhouseL0DEifuAj2Meta?.path ?? "/our-homes/home-collections/easyhouse",
    meta: easyhouseL0DEifuAj2Meta || {},
    alias: easyhouseL0DEifuAj2Meta?.alias || [],
    redirect: easyhouseL0DEifuAj2Meta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue").then(m => m.default || m)
  },
  {
    name: limitededitionxtULVOTHybMeta?.name ?? "our-homes-home-collections-limitededition",
    path: limitededitionxtULVOTHybMeta?.path ?? "/our-homes/home-collections/limitededition",
    meta: limitededitionxtULVOTHybMeta || {},
    alias: limitededitionxtULVOTHybMeta?.alias || [],
    redirect: limitededitionxtULVOTHybMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue").then(m => m.default || m)
  },
  {
    name: wee_45cottagepD4K2dk9z3Meta?.name ?? "our-homes-home-collections-wee-cottage",
    path: wee_45cottagepD4K2dk9z3Meta?.path ?? "/our-homes/home-collections/wee-cottage",
    meta: wee_45cottagepD4K2dk9z3Meta || {},
    alias: wee_45cottagepD4K2dk9z3Meta?.alias || [],
    redirect: wee_45cottagepD4K2dk9z3Meta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue").then(m => m.default || m)
  },
  {
    name: indexJUyLThjukxMeta?.name ?? "our-homes",
    path: indexJUyLThjukxMeta?.path ?? "/our-homes",
    meta: indexJUyLThjukxMeta || {},
    alias: indexJUyLThjukxMeta?.alias || [],
    redirect: indexJUyLThjukxMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue").then(m => m.default || m)
  },
  {
    name: our_45neighborhoodsMWelmsyOlJMeta?.name ?? "our-neighborhoods",
    path: our_45neighborhoodsMWelmsyOlJMeta?.path ?? "/our-neighborhoods",
    meta: our_45neighborhoodsMWelmsyOlJMeta || {},
    alias: our_45neighborhoodsMWelmsyOlJMeta?.alias || [],
    redirect: our_45neighborhoodsMWelmsyOlJMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue").then(m => m.default || m)
  },
  {
    name: partner_45with_45us1CagWEcvsnMeta?.name ?? "partner-with-us",
    path: partner_45with_45us1CagWEcvsnMeta?.path ?? "/partner-with-us",
    meta: partner_45with_45us1CagWEcvsnMeta || {},
    alias: partner_45with_45us1CagWEcvsnMeta?.alias || [],
    redirect: partner_45with_45us1CagWEcvsnMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue").then(m => m.default || m)
  },
  {
    name: peacockd9ySbgvt7gMeta?.name ?? "peacock",
    path: peacockd9ySbgvt7gMeta?.path ?? "/peacock",
    meta: peacockd9ySbgvt7gMeta || {},
    alias: peacockd9ySbgvt7gMeta?.alias || [],
    redirect: peacockd9ySbgvt7gMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/peacock.vue").then(m => m.default || m)
  },
  {
    name: privacytermsmC2DDu25oIMeta?.name ?? "privacyterms",
    path: privacytermsmC2DDu25oIMeta?.path ?? "/privacyterms",
    meta: privacytermsmC2DDu25oIMeta || {},
    alias: privacytermsmC2DDu25oIMeta?.alias || [],
    redirect: privacytermsmC2DDu25oIMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/privacyterms.vue").then(m => m.default || m)
  },
  {
    name: sandboxCEG5UviQVWMeta?.name ?? "sandbox",
    path: sandboxCEG5UviQVWMeta?.path ?? "/sandbox",
    meta: sandboxCEG5UviQVWMeta || {},
    alias: sandboxCEG5UviQVWMeta?.alias || [],
    redirect: sandboxCEG5UviQVWMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93VgXoNwIMBgMeta?.name ?? "videos-slug",
    path: _91_46_46_46slug_93VgXoNwIMBgMeta?.path ?? "/videos/:slug(.*)*",
    meta: _91_46_46_46slug_93VgXoNwIMBgMeta || {},
    alias: _91_46_46_46slug_93VgXoNwIMBgMeta?.alias || [],
    redirect: _91_46_46_46slug_93VgXoNwIMBgMeta?.redirect,
    component: () => import("/codebuild/output/src151978934/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue").then(m => m.default || m)
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/about-us/get-our-brochure/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/about-us/in-the-news/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/about-us/realtor-program/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/about-us/what-we-do/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/about-us/who-we-are/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/build-with-us/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/career-opportunities/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/career-opportunities/administrative-assistant-2/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/career-opportunities/director-of-warranty-services/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/career-opportunities/land-development-entitlements-coordinator/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/contact-us/ask-a-question/thank-you/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/contact-us/warranty-services/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/email-signup/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/get-updates/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/get-updates/thank-you/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/how-to-video-library/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/lifestyle/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/locations/lanterns-at-rock-creek/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/locations/silver-leaf/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/locations/wee-cottage-at-north-end-80238/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/locations/wee-cottage-at-rogers-farm/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/locations/west-edge-at-colliers-hill/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/login/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/lost-password/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/maintenance-items/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/marshall-fire-response/thank-you-loi/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/neighborhoods-map-test/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/organism-page/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/our-homes/home-collections/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/our-homes/home-collections/lanterns-series/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/our-homes/home-collections/opportunities-series/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/our-homes/photo-gallery/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/our-homes/photo-gallery/gourmet-kitchens/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/our-homes/photo-gallery/home-offices/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/our-homes/photo-gallery/living-rooms/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/our-homes/photo-gallery/outdoor-living-spaces/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/our-homes/photo-gallery/relaxing-master-suites/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/register/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/reset-password/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/resources-lower-maintenance/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/style-guide/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  },
  {
    name: component_45stub2sI0tKXwdQMeta?.name ?? undefined,
    path: component_45stub2sI0tKXwdQMeta?.path ?? "/warranty-service-request/",
    meta: component_45stub2sI0tKXwdQMeta || {},
    alias: component_45stub2sI0tKXwdQMeta?.alias || [],
    redirect: component_45stub2sI0tKXwdQMeta?.redirect,
    component: component_45stub2sI0tKXwdQ
  }
]